import { atom } from "recoil";

import { AuthUserInfo } from "../types/auth";
import keys from "./constants";

export type AuthState = AuthUserInfo | null;

export const authState = atom<AuthState>({
  key: keys.AUTH_STATE,
  default: null,
  dangerouslyAllowMutability: true
});
